<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>网关管理</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
          <el-button type="success" style="float: right;margin-right:20px" @click="onimport">批量导入</el-button>
          <el-button type="primary" style="float: right;margin-right:20px" @click="exportExcel">导出</el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{type:'del',para:multipleSelection}">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入网关名称或编号搜索" v-model="search"
            @keyup.enter.native="searchBtn">
          </el-input>
          <el-select v-model="status" clearable placeholder="状态" @change="changeStatus">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"
            :class="search.length == 0 ? 'ccc' : 'blue'"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" min-width="150px">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号"></el-table-column>
          <el-table-column prop="protocolName" label="协议">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="toModuleProtocolPage(scope.row.protocolId)">
                {{ scope.row.protocolName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="onlineStatus" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.onlineStatus==0"> <i class="redDot"></i>离线</span>
              <span v-else-if="scope.row.onlineStatus==1"> <i class="greenDot"></i>在线</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column prop="encryptType" label="加密类型">
            <template slot-scope="scope">
              <span v-if="scope.row.encryptType==0">不加密</span>
              <span v-else-if="scope.row.encryptType==1">sm2加密</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column prop="offlineCheckInterval" label="离线检测间隔" :formatter="checkIntervalFormatter"
            align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" :formatter="dateFormat"></el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ type: 'edit', id: scope.row.id }">编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    :command="{ type: 'to_reset_encrypt', id: scope.row.id, currentModuleCode: scope.row.code, encryptType: scope.row.encryptType }">
                    重置密钥</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'log', code: scope.row.code }">日志
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'onlineDetail', onlineDetailMdu: scope.row }">
                    在线情况
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'instruction', row: scope.row}">
                    下发指令历史列表
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.onlineStatus == 1 && (commuType == 1 || commuType == 2 || commuType == 3 )"
                    :command="{ type: 'disconnect', code: scope.row.code,id:scope.row.id }">断开连接
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="'网关（'+currentModuleCode+'）重置密钥'" :visible.sync="maskVisible" width="30%">
      <span style="margin-left:5%;color:red;">此操作将会时当前网关加密不可用，要重新配置网关加密信息</span>
      <div style="margin-top:5%;margin-left:30%;">
        <div class="subheading" style="margin-bottom:5%;">请选择加密类型:</div>
        <el-select v-model="encryptType" filterable placeholder="未选择">
          <el-option v-for="item in encryptTypeList" :key="item.id" :label="item.content" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="maskVisible = false">取 消</el-button>
        <el-button type="primary" @click="reset_encrypt">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除结果弹出框 -->
    <el-dialog :title="'删除结果'" :visible.sync="delErrorMsgMaskVisible" width="30%" :close-on-click-modal="false">
      <el-table ref="multipleTable" :data="delErrorMsgTableData" :border="true">
        <el-table-column prop="code" label="编号" align="center"></el-table-column>
        <el-table-column prop="errorMsg" label="错误信息">
          <template slot-scope="scope">
            <span style="color: #ff0000;">{{ scope.row.errorMsg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delErrorMsgResultOff">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="empty">
      <el-card class="box-card">
        <img src="../../assets/images/wangguan.png" alt="" />
        <p style="color:#303133">您还没有创建任何网关</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建网关</el-button>
        <el-button type="success" @click="onimport">批量导入</el-button>
      </el-card>
    </div>
    <el-dialog :title="`网关（${onlineDetailMdu.name}，编号：${onlineDetailMdu.code}）在线情况`" :visible.sync="onlineDialog"
      :close-on-click-modal="false" :show-close="false">
      <div>
        <div style="text-align: right">
          <el-date-picker v-model="onlineTime" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" @change="getOnlineDetailData">
          </el-date-picker>
          <el-button type="primary" @click="getOnlineDetailData">搜索</el-button>
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="dev-onOrOffline-dev">
              <el-timeline>
                <el-timeline-item :class="[state.textClass,state.lineClass]"
                  v-for="(state, index) in onlineData.timeline" :key="index" :icon="index==0?'el-icon-arrow-up':''"
                  :type="state.type" :hide-timestamp="index==0" :timestamp="state.createDate">
                  <span>{{state.text}}</span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
          <el-col :span="18">
            <div id="moduleSingleOnline" style="width: 100%;height: 300px"></div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onlineDialog = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量导入" :visible.sync="batchImportDialog" width="30%" :close-on-click-modal="false">
      下载模板：<a href="./static/template/moduleTemplate.xls">模板</a>
      <el-form ref="uploadForm" :model="uploadForm">
        <el-form-item label="文件上传：" prop="attachmentId"><br />
          <el-upload :action="upload" :data="tokenData" ref="uploadRef" class="upload-demo" :auto-upload="false" drag
            :on-success="successHandle" :limit="1" accept=".xls,.xlsx,application/vnd.ms-excel" :with-credentials='true'
            :headers="myHeaders" :file-list="fileList" :on-change="uploadCharge" :on-remove="removeUpload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="网关协议：" prop="mduProtocolId"><br />
          <div>
            <el-select v-model="uploadForm.mduProtocolId" filterable placeholder="未选择">
              <el-option v-for="item in mduProtocolList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importExcel">开始导入</el-button>
        <el-button type="primary" @click="closeBatchImportDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 下发历史列表 -->
    <automaticGateway ref="automaticGateway" />

  </div>
</template>
<script>
  // 引入基本模板
  let echarts = require("echarts/lib/echarts");
  // 引入折线图组件
  require("echarts/lib/chart/line");
  // 引入提示框和title组件
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  require("echarts/lib/component/legend");
  import API from "../../api/api";
  import dayjs from "dayjs";
  import automaticGateway from './automaticGateway.vue'
  export default {
    components: {
      automaticGateway
    },
    data() {
      return {
        commuType: sessionStorage.getItem('commuType'),
        delErrorMsgMaskVisible: false,
        delErrorMsgTableData: [],
        currentModuleId: '',
        currentModuleCode: '',
        encryptType: 0,
        maskVisible: false,
        empty: false, //控制数据为空展示空页面
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        status: "", //状态下拉数据
        statusList: [
          //状态数组
          {
            value: 1,
            label: "在线"
          },
          {
            value: 0,
            label: "离线"
          }
        ],
        encryptTypeList: [{
          id: 0,
          content: '不加密'
        },
        {
          id: 1,
          content: 'sm2'
        }
        ],
        tableData: [],
        multipleSelection: [],
        onlineDialog: false, //展示网关在线情况模态框
        onlineDetailMdu: {}, //展示在线情况网关
        onlineData: {}, //单个设备在线率echart数据
        pickerOptions: { //时间选择器
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        onlineTime: [(new Date()).getTime() - 3600 * 1000 * 24 * 1, new Date()],
        mduProtocolList: [],
        batchImportDialog: false,
        upload: API.uploadModuleFile(), //上传地址
        myHeaders: {
          Authentication: this.$cookies.get('token')
        },
        uploadForm: {
          mduProtocolId: ''
        },
        fileList: [],
        fileCount: 0, //文件个数
        moduleParams: {
          search: '',
          status: ''
        }
      };
    },
    computed: {
      tokenData: function () {
        return {
          mduProtocolId: this.uploadForm.mduProtocolId,
          access_token: this.$cookies.get('access_token'),
          commuType: this.commuType
        }
      }
    },
    created() {
      let search = JSON.parse(localStorage.getItem('moduleParams'));
      if (search) {
        this.search = search.search
        this.status = search.status
      }
    },

    methods: {


      uploadCharge(file, fileList) {
        this.fileCount = fileList.length
      },

      successHandle(data) {
        if (data.data == null) {
          this.$message.error(data.msg);
          return
        }

        let errCount = data.data.errCount
        let succCount = data.data.succCount
        let errList = data.data.errList
        this.$alert('成功：<strong style="color:green">' + succCount + '</strong>条<br>失败：<strong style="color:red">' +
          errCount +
          '</strong>条<br>失败记录：<br>' +
          errList.join("<br>"), '导入结果', {
          dangerouslyUseHTMLString: true
        });
      },

      removeUpload(file, fileList) {
        this.fileCount = fileList.length
      },

      importExcel() {
        if (this.fileCount == 0) {
          this.$message.warning('请选择文件')
          return false
        }
        this.$refs.uploadRef.submit();
      },

      onimport() {
        this.batchImportDialog = true
        this.getProtocolList()
      },

      closeBatchImportDialog() {
        this.batchImportDialog = false
        this.uploadForm.mduProtocolId = ''
        this.fileList = []
      },


      //查询网关协议下拉数据
      getProtocolList() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformMduModuleModuleProtocolList(param).then(res => {
          if (res.code == 1) {
            this.mduProtocolList = res.data.protocolList;
          }
        });
      },



      dateFormat(row, column, cellValue, index) {
        if (row[column.property]) {
          return dayjs(new Date(row[column.property])).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },
      toModuleProtocolPage(id) {
        if (!id) return;
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: id
          }
        });
      },

      //获取列表数据--只在进入页面时调用，不能复用
      getPage() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          // type: 1, //网关
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        this.getpageList()
      },
      //获取列表复用
      getpageList() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          search: this.search, //搜索栏
          onlineStatus: this.status, //下拉搜索
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformMduModulePage(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //网关导出
      exportExcel() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          search: this.search, //搜索栏
          onlineStatus: this.status, //下拉搜索
          pageSize:10000000,
          access_token: this.$cookies.get('access_token') ? this.$cookies.get('access_token') : ''
        };
        window.open(API.exportModuleUrl(para))
      },
      //搜索功能
      searchBtn() {
        // this.status = '', //下拉选项为空
        this.currentPage = 1
        this.moduleParams.search = this.search
        localStorage.setItem('moduleParams', JSON.stringify(this.moduleParams));
        this.getpageList();
      },
      //下拉搜索
      changeStatus() {
        // this.search = ""; //清空搜索条件
        this.moduleParams.status = this.status
        localStorage.setItem('moduleParams', JSON.stringify(this.moduleParams));
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.status = "";
        this.currentPage = 1
        localStorage.removeItem('moduleParams');
        this.getpageList();
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量操作-删除
      operationBtn(val) {
        if (val.type == 'del') {
          let arr = []
          val.para.forEach(element => {
            arr.push(element.id)
          });
          let str = arr.join(',')
          this.delBtn(str)
        }
      },
      //单独删除功能
      command(val) {
        if (val.type == 'del') {
          let str = val.id
          this.delBtn(str)
        } else if (val.type == 'to_reset_encrypt') {
          this.encryptType = val.encryptType;
          this.currentModuleCode = val.currentModuleCode;
          this.currentModuleId = val.id;
          this.to_reset_encrypt()
        } else if (val.type == 'edit') {
          this.$router.push({
            path: "/device/moduleAdd",
            query: {
              id: val.id,
              flag: 'edit'
            }
          });
        } else if (val.type == 'log') {
          this.$router.push({
            path: "/device/moduleLog",
            query: {
              moduleCode: val.code,
            }
          });
        } else if (val.type == 'onlineDetail') {
          this.onlineDetailMdu = val.onlineDetailMdu;
          this.onlineTime = [(new Date()).getTime() - 3600 * 1000 * 24 * 1, new Date()]
          this.onlineDialog = true;
          this.getOnlineDetailData()
        } else if (val.type == 'disconnect') {
          let param = {
            moduleCode: val.code,
            commuType: this.commuType,
            id: val.id
          }
          console.log(param);

          API.disconnectModule(param).then(res => {
            if (res.code == 1) {
              this.$message.success('成功');
            } else {
              this.$message.error('失败');
            }
          })
        } else if (val.type == 'instruction') {
          let obj = {
            name: val.row.name,
            code: val.row.code
          }
          this.$refs.automaticGateway.show(obj)
        }
      },
      to_reset_encrypt() {
        this.$confirm('此操作将会时当前网关加密不可用，要重新配置网关加密信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.maskVisible = true;
        }).catch(() => {
          this.maskVisible = false;
          this.$message({
            type: 'info',
            message: '已取消重置密钥'
          });
        });
      },
      reset_encrypt() {
        let param = {
          id: this.currentModuleId,
          encryptType: this.encryptType,
        }
        API.resetMduEncrypt(param).then(res => {
          if (res.code == 1) {
            this.maskVisible = false;
            this.$message.success('重置成功');
          } else {
            this.$message.error('重置失败');
          }
        })
      },
      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        }
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformMduModule(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList();
            } else {
              var falseList = res.data;
              this.delErrorMsgTableData = [];
              this.tableData.forEach(item => {
                falseList.forEach(errMsg => {
                  if (errMsg.indexOf(item.id) != -1) {
                    this.delErrorMsgTableData.push({
                      code: item.code,
                      errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                    })
                    return;
                  }
                })
              });
              this.delErrorMsgMaskVisible = true;
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //关闭删除结果
      delErrorMsgResultOff() {
        this.delErrorMsgMaskVisible = false;
        this.getpageList();
      },
      //获取在线情况数据
      getOnlineDetailData() {
        if (!this.onlineDetailMdu.id || this.onlineTime.length < 2) {
          return false;
        }
        let para = {
          moduleId: this.onlineDetailMdu.id,
          startDateStr: dayjs(this.onlineTime[0]).format("YYYY-MM-DD 00:00:00"),
          endDateStr: dayjs(this.onlineTime[1]).format("YYYY-MM-DD 23:59:59"),
        };
        this.onlineData = {};
        API.DashboardOnlineDetail(para)
          .then(res => {

            if (res.code == 1) {
              this.onlineData = res.data
              this.onlineData.timeline = this.formatTimelineData(this.onlineData.moduleOnlineRecords)
              this.moduleSingleOnline();
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /**单个网关在线情况echart图**/
      moduleSingleOnline() {
        // 基于准备好的dom，初始化echarts实例
        let moduleSingleOnline = echarts.init(
          document.getElementById("moduleSingleOnline")
        );
        var data = this.onlineData;
        var mduData = [];
        for (let n = 0; n < data.moduleOnlineRecords.length; n++) {
          mduData.push([data.moduleOnlineRecords[n].createDate, data.moduleOnlineRecords[n].deviceStatus])
        }
        moduleSingleOnline.setOption({
          color: ["#FF8B9F"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line" // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              var res = '<div><p>时间：' + dayjs(new Date(params[0].value[0])).format('YYYY-MM-DD HH:mm') +
                '</p></div>'
              for (var i = 0; i < params.length; i++) {
                res += '<p>' + params[i].seriesName + ':  ' + (params[i].data[1] == 1 ? "在线" : "离线") + '</p>'
              }
              return res;
            },
          },
          legend: {
            data: [data.moduleName + '（' + data.moduleCode + '）'],
            x: "60px"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "time",
            boundaryGap: false,
            name: "时间",
            splitLine: {
              show: false
            },
          },
          yAxis: {
            type: "value",
            boundaryGap: false,
            min: 0,
            max: 1,
            minInterval: 1,
            axisLabel: {
              formatter: function (value) {
                var texts = [];
                if (value == 0) {
                  texts.push('离线');
                } else if (value == 1) {
                  texts.push('在线');
                }
                return texts;

              }
            }
          },
          series: [{
            name: data.moduleName,
            type: "line",
            step: 'end',
            label: {
              normal: {
                show: false
              }
            },
            data: mduData
          }],
          dataZoom: [{
            type: 'inside',
          }],
        });
        window.addEventListener("resize", function () {
          moduleSingleOnline.resize();
        });
      },
      //跳转到详情页
      detailBtn(id) {
        //  直接调用$router.push 实现携带参数的跳转
        this.$router.push({
          path: "/device/moduleDetail",
          query: {
            id: id
          }
        });
      },
      //跳转创建网关页
      addBtn() {
        this.$router.push({
          path: "/device/moduleAdd"
        });
      },
      //检测时间间隔格式转换
      checkIntervalFormatter(row) {
        var time = row.offlineCheckInterval;
        var returnNum;
        var returnUmit;
        if (time == '' || time == null) {
          returnNum = '---'
        } else if (time >= 43200) {
          returnNum = (time / 43200).toFixed(2)
          returnUmit = ' 个月'
        } else if (time >= 10080) {
          returnNum = (time / 10080).toFixed(2)
          returnUmit = ' 周'
        } else if (time >= 1440) {
          returnNum = (time / 1440).toFixed(2)
          returnUmit = ' 天'
        } else if (time > 180) {
          returnNum = (time / 60).toFixed(2)
          returnUmit = ' 小时'
        } else {
          returnNum = time
          returnUmit = ' 分钟'
        }
        if (returnNum.length > 3 && returnNum.substring(returnNum.length - 3) == '.00') {
          returnNum = returnNum.split(".")[0]
        }
        return returnNum + returnUmit
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.getpageList();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList();
      },
      /***格式化在线状态时间线数据****/
      formatTimelineData(arr) {
        let timelineData = []
        let nextState = 0
        let [onlineText, onlineLine, offlineText, offlineLine] = ['onlineText', 'onlineLine', 'offlineText', 'offlineLine']
        for (let i = 0; i < arr.length; i++) {
          let { deviceStatus, createDate } = arr[i];

          let text;
          if (i == 0) {
            text = (deviceStatus == 1 ? '网关在线状态' : '网关离线状态')
          } else {
            text = (i == arr.length - 1 ? (deviceStatus == 1 ? '当前网关状态-网关在线' : '当前网关状态-网关离线') : (deviceStatus == 1 ? '网关上线' : '网关离线'))
          }

          timelineData.unshift({
            deviceStatus: deviceStatus,
            createDate: dayjs(new Date(createDate)).format("YYYY-MM-DD HH:mm:ss"),
            textClass: deviceStatus == 1 ? onlineText : offlineText,
            lineClass: nextState == 1 ? onlineLine : offlineLine,
            type: deviceStatus == 1 ? 'success' : 'danger',
            text: text
          })
          nextState = deviceStatus
        }
        return timelineData;
      },
    },
    mounted() {
      this.getPage();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/moduleManagement.vue